import { BellIcon } from '@phosphor-icons/react';
import { MoonIcon, SunIcon } from '@phosphor-icons/react';

interface StoredUser {
    fullname?: string;
    email?: string;
}

interface AccountHeaderProps {
    isDark: boolean;
    onToggleTheme: () => void;
}

const AccountHeader = ({ isDark, onToggleTheme }: AccountHeaderProps) => {
    const raw = localStorage.getItem('userData');
    const user: StoredUser | null = raw ? JSON.parse(raw) : null;

    return (
        <div className="flex items-center gap-3 shrink-0">
            <BellIcon size={20} color={isDark ? '#fff' : '#374151'} className="cursor-pointer shrink-0" />

            <button
                onClick={onToggleTheme}
                className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
                aria-label="Toggle theme"
            >
                {isDark
                    ? <SunIcon size={18} className="text-gray-300" />
                    : <MoonIcon size={18} className="text-gray-800" />}
            </button>

            <div className="flex flex-col items-end leading-tight">
                <span className="text-sm font-semibold text-text-primary">
                    {user?.fullname || 'Admin'}
                </span>
                <span className="text-xs text-text-muted">
                    {user?.email || ''}
                </span>
            </div>

            <button
                className="h-8 px-3 rounded-md bg-red-500 hover:bg-red-600 text-white text-sm font-medium transition-colors"
                onClick={() => {
                    localStorage.removeItem('user');
                    localStorage.removeItem('token');
                    localStorage.removeItem('userId');
                    window.location.href = '/login';
                }}
            >
                Đăng xuất
            </button>
        </div>
    );
};

export default AccountHeader;
